__turbopack_context__.v({
  "fadeIn": "TableOfContents-module__jTVmNG__fadeIn",
  "fadeInBackdrop": "TableOfContents-module__jTVmNG__fadeInBackdrop",
  "fadeOut": "TableOfContents-module__jTVmNG__fadeOut",
  "fadeOutBackdrop": "TableOfContents-module__jTVmNG__fadeOutBackdrop",
  "slideDown": "TableOfContents-module__jTVmNG__slideDown",
  "slideDownDrawer": "TableOfContents-module__jTVmNG__slideDownDrawer",
  "slideUp": "TableOfContents-module__jTVmNG__slideUp",
  "slideUpDrawer": "TableOfContents-module__jTVmNG__slideUpDrawer",
});
